import { useEffect } from 'react'

import { useStore } from '../models'

export const useWalkthroughNextStep = () => {
  const {
    game: { step, goToNextStep, walkthroughType }
  } = useStore()

  useEffect(() => {
    let timeout: number | null = null

    if (walkthroughType === 'TableTour' && (step === 4 || step === 5)) {
      timeout = setTimeout(() => {
        goToNextStep()
      }, 1500)
    } else if (timeout) {
      clearTimeout(timeout)
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [step, goToNextStep, walkthroughType])
}
